import atLeastOneNecessary from './atLeastOneNecessary'
import necessityAndProportionalitiesConstants from 'constants/necessityAndProportionalities'

const verifyUnnecessaryScopes = (data, handleOpenDialog) => {
  const dataCollectedAtLeastOneNecessary = atLeastOneNecessary(
    data,
    'collectedField',
  )
  const lifeCycleAtLeastOneNecessary = atLeastOneNecessary(
    data,
    'dataLifeCycle',
  )

  if (!dataCollectedAtLeastOneNecessary && !lifeCycleAtLeastOneNecessary)
    return handleOpenDialog(
      necessityAndProportionalitiesConstants.BOTH_WARNING_MESSAGE,
    )
  if (!dataCollectedAtLeastOneNecessary)
    return handleOpenDialog(
      necessityAndProportionalitiesConstants.DATA_COLLECTED_WARNING_MESSAGE,
    )
  if (!lifeCycleAtLeastOneNecessary)
    return handleOpenDialog(
      necessityAndProportionalitiesConstants.LIFE_CYCLE_WARNING_MESSAGE,
    )
}

export default verifyUnnecessaryScopes
